export default function setCancelableTimeout(func: () => void, delay: number): () => void {
  const timer = setTimeout(func, delay)
  return () => {
    clearTimeout(timer)
  }
}